import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { User } from '@upmc-healthplan-npm/oidc-client';
import { IMyOaasResponse, IPOLUserResponse, IProvider, IProviderPreferenceResponse, IUser } from '../models/state.model';

export const actionSignInUser = createAction('[POL Core] Sign In User', props<{ user: User }>());

export const actionSignOutUser = createAction('[POL Core] Sign Out User');

export const actionGetPOLUserProfileSuccess = createAction(
  '[POL Core] Get POL User Profile SUCCESS',
  props<{ profile: IPOLUserResponse }>()
);

export const actionGetPOLUserProfileFailure = createAction(
  '[POL Core] Get POL User Profile FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const actionSetUserProviderType = createAction(
  '[POL Core] Set User Provider Type',
  props<{ providerType: string }>()
);

export const actionLoadUserFromSessionStorage = createAction(
  '[POL Core] Load User From Session Storage',
  props<{ user: any }>()
);

export const actionRefreshToken = createAction(
  '[POL Core] Refresh Token',
  props<{ refreshToken: { isRefreshInProgress: boolean; url: string; resetInactivityTime?: boolean } }>()
);


export const resetInactivityTime = createAction('[POL Core] Reset Inactivity Time');

export const actionGetUserPreferences = createAction('[POL Core] Get User Preferences');

export const actionGetUserPreferencesSuccess = createAction(
  '[POL Core] Get User Preferences Success',
  props<{ user: IUser }>()
);

export const actionGetUserPreferencesFailure = createAction(
  '[POL Core] Get User Preferences Failure',
  props<{ error: HttpErrorResponse }>()
);

export const actionUpdateUserPreferences = createAction('[POL Core] Update User Preferences', props<{ user: IUser }>());

export const actionUpdateUserPreferencesSuccess = createAction(
  '[POL Core] Update User Preferences Success',
  props<{ user: IUser }>()
);

export const actionUpdateUserPreferencesFailure = createAction(
  '[POL Core] Update User Preferences Failure',
  props<{ error: HttpErrorResponse }>()
);

export const actionSetFavoriteProviders = createAction(
  '[POL Core Provider] Set favorite provider',
  props<{ favoriteProviders: IProvider[] }>()
);

export const actionAddFavoriteProvider = createAction(
  '[POL Core Provider] Add favorite provider',
  props<{ favoriteProvider: IProvider }>()
);

export const actionRemoveFavoriteProvider = createAction(
  '[POL Core Provider] Remove favorite provider',
  props<{ favoriteProvider: IProvider }>()
);

export const actionRemoveFavoriteProviderSuccess = createAction(
  '[POL Core Provider] Remove favorite provider Success',
  props<{ favoriteProvider: IProvider }>()
);

export const actionRemoveFavoriteProviderFailure = createAction(
  '[POL Core Provider] Remove favorite provider SuccErroress',
  props<{ favoriteProvider: IProvider; error: any  }>()
);

export const actionAddFavoriteProviderFailure = createAction(
  '[POL Core Provider] Add favorite provider failure',
  props<{ favoriteProvider: IProvider; error: any }>()
);

export const actionAddFavoriteProviderSuccess = createAction(
  '[POL Core Provider] Add favorite provider Success',
  props<{ favoriteProvider: IProvider; }>()
);

export const actionGetMyOaas = createAction(
  '[POL Core Provider] Get My Oaas'
);

export const actionGetMyOaasFailure = createAction(
  '[POL Core Provider] Get My Oaas Failure',
  props<{ error: any }>()
);

export const actionGetMyOaasSuccess = createAction(
  '[POL Core Provider] Get My Oaas Success',
  props<{ myOaas: IMyOaasResponse }>()
);

/* Profile Page - Bookmark Providers Actions - START */

export const getFavoriteProviders = createAction('[POL Core Provider] Get Favorite Providers');

export const getFavoriteProvidersSuccess = createAction(
  '[POL Core Provider] Get Favorite Providers SUCCESS',
  props<{ favoriteProviders: IProviderPreferenceResponse }>()
);

export const getFavoriteProvidersFailure = createAction(
  '[POL Core Provider] Get Favorite Providers FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const addFavoriteProvider = createAction(
  '[POL Core Provider] Add Favorite Provider',
  props<{ favoriteProvider: IProvider }>()
);

export const addFavoriteProviderSuccess = createAction(
  '[POL Core Provider] Add Favorite Provider Success',
  props<{ favoriteProviders: IProviderPreferenceResponse }>()
);

export const addFavoriteProviderError = createAction(
  '[POL Core Provider] Add Favorite Provider Error',
  props<{ error: HttpErrorResponse }>()
);

export const removeFavoriteProvider = createAction(
  '[POL Core Provider] Remove Favorite Provider',
  props<{ favoriteProvider: IProvider }>()
);

export const removeFavoriteProviderSuccess = createAction(
  '[POL Core Provider] Remove Favorite Provider Success',
  props<{ favoriteProviders: IProviderPreferenceResponse }>()
);

export const removeFavoriteProviderError = createAction(
  '[POL Core Provider] Remove Favorite Provider Error',
  props<{ error: HttpErrorResponse }>()
);

export const resetFavoriteProviders = createAction('[POL Core Provider] Reset Favorite Providers');

export const resetFavoriteProvidersSearch = createAction('[POL Core Provider] Reset Favorite Providers Search');

export const resetProviderSearchResults = createAction('[POL Core Provider] Reset Provider Search Results');

export const setSelectedProvider = createAction(
  '[POL Core Provider] Set Selected Provider',
  props<{ selectedProvider: IProvider }>()
);

export const setProviderSearchResults = createAction(
  '[POL Core Provider] Set Provider Search Results',
  props<{ providerSearchResults : any }>()
);

export const resetIdleTimeout = createAction('[POL Core] Reset Idle Timeout');

export const disableUserMenu = createAction(
  '[POL Core] Should disable user menu',
  props<{ shouldDisable: boolean }>()
);
